"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AppAriImpls_1 = require("./AppAriImpls");
var AppFamilyAri;
(function (AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [AppFamilyAri.appResourceType, AppFamilyAri.environmentResourceType, AppFamilyAri.extensionGroupResourceType, AppFamilyAri.extensionResourceType];
})(AppFamilyAri = exports.AppFamilyAri || (exports.AppFamilyAri = {}));
class AppFamilyAriError extends Error {
    constructor(message, cause) {
        super(message);
        this.cause = cause;
    }
}
exports.AppFamilyAriError = AppFamilyAriError;
class NotAppFamilyAriError extends AppFamilyAriError {
    constructor(ari, reason) {
        super(`ari is not a valid App family ari: ${ari.toString()} as ${reason}`);
        this.reason = reason;
    }
}
exports.NotAppFamilyAriError = NotAppFamilyAriError;
class NotExpectedAppFamilyAriTypeError extends AppFamilyAriError {
    constructor(type, ari, cause) {
        super(`App family ari (${ari.toString()}) is not of expected type: ${type}`, cause);
        this.cause = cause;
    }
}
exports.NotExpectedAppFamilyAriTypeError = NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */
function parseAppAri(ari) {
    return AppAriImpls_1.AppFamilyAriImpl.parse(ari);
}
exports.parseAppAri = parseAppAri;
function createAppAri(json) {
    return new AppAriImpls_1.AppFamilyAriImpl(json);
}
exports.createAppAri = createAppAri;
//# sourceMappingURL=AppAris.js.map